<template>
    <button class="entry" @click="showProgress">
        <svg class="arrow-ctnr" :class="{'disable': entry.hideArrow}" width="50" height="70" viewBox="0 0 50 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="arrow" d="M19 18L30 35L19 52" stroke="black" stroke-width="4" shape-rendering="geometricPrecision"/>
        </svg>
        <h2 class="title">
            <span class="title-type">{{entry.type}}</span>
            <span>{{entry.title}}<span class="at-symbol">&nbsp;@&nbsp;</span>{{entry.company}}</span>
            <svg class="loader" :class="{'active': loaderVisible}" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="loader-path" d="M9.5 2C5.35786 2 2 5.35786 2 9.5C2 13.6421 5.35786 17 9.5 17C13.6421 17 17 13.6421 17 9.5C17 5.35786 13.6421 2 9.5 2Z" stroke="black" stroke-width="3"/>
            </svg>
        </h2>
        <p class="summary">{{entry.summary}}</p>
        <div class="tags">
            <p class="tag" v-for="i in 5" :key="i" :class="{'disable': !entry.tags[i-1]}">
                {{tagTitles[i-1]}}
            </p>
        </div>
    </button>
</template>

<script>
export default {
    props: ['entry'],
    data() {
        return {
            tagTitles: ['Ideate', 'Wireframe', 'Design', 'Develop', 'Audit'],
            loaderVisible: false
        }
    },
    methods: {
        showProgress() {
            this.loaderVisible = true;
            setTimeout(()=> {
                this.loaderVisible = false;
            }, 2500);
        }
    }
    
}
</script>

<style scoped lang="scss">
.loader {
    margin-left: 10px;
    top: 1px;
    &.active {
        .loader-path {
            animation: dash 4s linear forwards;
        }
    }
}

    
.loader-path {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
}
@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
.entry {
    margin-right: 50%;
    padding: 50px 0;
    text-align: unset;
    cursor: pointer;
    &:nth-of-type(1){
        padding-top: 220px;
    }
    &:hover, 
    &:focus,
    &:active {
        outline: none;
        background-color: transparent;
        .arrow-ctnr {
            opacity: 1;
        }
    }
    h2.title {
        flex-grow: 2;
    }
    .summary {
        max-width: 650px;
    }
    .tags {
        display: flex;
        .tag {
            margin-right: 10px;
            &:nth-of-type(1) {
                border-color: var(--color-tag-0);
            }
            &:nth-of-type(2) {
                border-color: var(--color-tag-1);
            }
            &:nth-of-type(3) {
                border-color: var(--color-tag-2);
            }
            &:nth-of-type(4) {
                border-color: var(--color-tag-3);
            }
            &:nth-of-type(5) {
                border-color: var(--color-tag-4);
            }
        }
    }
    .arrow-ctnr {
        position: absolute;
        left: -40px;
        margin-top: -22px;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
        &.disable {
            opacity: 0;
        }
        .arrow {
            // animation-name: grow;
            animation-duration: 1.5s;
            animation-iteration-count: infinite;
            animation-timing-function: ease-in-out;
            transform: scale(0.8, 0.6);
            transform-origin: 0px 30px;
            animation-delay: 0.5s;
        }
    }
}

.progress-ctnr {
    display: flex;
    flex-grow: 1;
    height: 4px;
    margin-left: 10px;
    margin-top: 3px;
    &.active {
        .progress-bar {
            width: 100%;
            transition-delay: 0s;
            transition: width 2s ease-in-out;
        }
    }
    .progress-bar {
        height: 100%;
        width: 0%;
        background-color: var(--color-dark);
        transition: width 0s ease-in-out;
        transition-delay: 0.5s;
    }
}

@media screen and (max-width: 810px) {
    .entry {
        width: 100%;
        padding: 30px 0;
        &:nth-of-type(1){
            padding-top: 180px;
        }
        .arrow-ctnr {
            left: -38px;
            display: none;
        }
        h2.title {
            line-height: 15px;
            .at-symbol {
                margin: 0 !important;
            }
        }
        .summary {
            max-width: 100%;
            min-width: 100%;
            font-size: 11px;
            line-height: 17px;
            margin-bottom: 15px;
        }
        .tags {
            flex-flow: row wrap;
            .tag {
                padding: 0 8px;
                // padding-bottom: 1px;
                height:26px;
                margin-right: 5px !important;
                margin-bottom: 5px;
                font-size: 10px !important;
            }
        }
    }
}

@keyframes grow {
    0% {
        transform: scale(0.9);
    }
    50% {
        transform: scale(1);
    }
    100% {
        transform: scale(0.9);
    }
}
</style>